<template>
  <div class="broker-auth-audit">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>经纪人认证审核列表</span>
      </div>

      <div class="search-form">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="姓名/手机号">
            <el-input v-model="searchForm.brokerInfo" placeholder="姓名/手机号" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="资料状态">
            <el-select v-model="searchForm.authStatus" placeholder="待审核" clearable style="width: 120px;">
              <el-option label="待审核" value="pending"></el-option>
              <el-option label="已通过" value="approved"></el-option>
              <el-option label="已拒绝" value="rejected"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交日期">
            <el-date-picker
              v-model="searchForm.createTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 150px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" style="background: #10B981; border-color: #10B981;">
              <i class="el-icon-search"></i> 查 询
            </el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        stripe
        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500 }"
        :row-style="{ height: '60px' }"
        v-loading="loading"
        size="small"
      >
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column label="企业名称" min-width="150" align="center">
          <template slot-scope="scope">
            <span 
              v-if="scope.row.companyName" 
              class="clickable-field" 
              @click="handleView(scope.row, 'view')"
            >
              {{ scope.row.companyName }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="经纪人" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.contactPerson || scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="联系电话" width="150" align="center">
          <template slot-scope="scope">
            {{ getMaskedPhone(scope.row.contactPhone || scope.row.phone) }}
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.authStatus)" size="mini" effect="light">
              {{ getStatusText(scope.row.authStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.authStatus === 'pending'" size="mini" type="primary" @click="handleView(scope.row, 'audit')" style="background: #409EFF; border-color: #409EFF;">
              去审核
            </el-button>
            <span v-else></span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        style="margin-top: 20px; text-align: right;"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      title="认证详情"
      :visible.sync="detailVisible"
      width="1200px"
      top="3vh"
      :close-on-click-modal="false"
    >
      <div v-if="currentRow" class="detail-container">
        <div class="left-section">
          <div class="section-title">
            <i class="el-icon-info"></i> 基础信息
          </div>
          <div class="basic-info">
            <div class="info-grid">
              <div class="info-grid-item">
                <div class="info-grid-label">企业名称</div>
                <div class="info-grid-value">{{ currentRow.companyName || '-' }}</div>
              </div>
              <div class="info-grid-item">
                              <div class="info-grid-label">联系人</div>
                              <div class="info-grid-value">{{ currentRow.contactPerson || currentRow.name || '-' }}</div>
                            </div>
              <div class="info-grid-item">
                <div class="info-grid-label">手机号码</div>
                <div class="info-grid-value">{{ currentRow.contactPhone || currentRow.phone || '-' }}</div>
              </div>
            </div>
          </div>

          <div class="section-title">
            <i class="el-icon-picture"></i> 营业执照
          </div>
          <div class="license-section">
            <div class="image-wrapper" @click="previewImage(currentRow.businessLicense)">
              <img v-if="currentRow.businessLicense" :src="getImageUrl(currentRow.businessLicense)" class="preview-image license-image" />
              <div v-else class="image-empty license-empty">
                <i class="el-icon-picture-outline"></i>
                <span>暂无营业执照图片</span>
              </div>
            </div>
          </div>
        </div>

        <div class="right-section">
          <div v-if="isAuditMode" class="section-title">
            <i class="el-icon-edit"></i> 审核操作
          </div>
          <div v-if="isAuditMode && currentRow.authStatus === 'pending'" class="audit-section">
            <el-form :model="auditForm" size="small">
              <el-form-item label="审核意见" label-position="top">
                <el-input
                  v-model="auditForm.remark"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入审核意见（拒绝时必填）"
                  maxlength="500"
                  show-word-limit
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
              <div class="audit-buttons">
                <el-button type="danger" @click="confirmReject" :loading="auditLoading">
                  拒绝申请
                </el-button>
                <el-button type="success" @click="confirmApprove" :loading="auditLoading" style="margin-left: 10px;">
                  审核通过
                </el-button>
              </div>
            </el-form>
          </div>
          <div v-else-if="!isAuditMode" class="audit-section">
            <div class="audit-result">
              <el-tag :type="getStatusType(currentRow.authStatus)" size="large" effect="dark">
                {{ getStatusText(currentRow.authStatus) }}
              </el-tag>
            </div>
          </div>

          <div class="section-title">
            <i class="el-icon-time"></i> 历史审核记录
          </div>
          <div class="audit-trail-section">
            <div v-if="auditLogs && auditLogs.length > 0" class="audit-trail">
              <div v-for="(log, index) in auditLogs" :key="log.id" class="audit-log-item">
                <div class="audit-log-header">
                  <span class="audit-operator">{{ log.operator }}</span>
                  <span class="audit-time">{{ formatTime(log.createTime) }}</span>
                </div>
                <div v-if="log.action == 'approve' || log.action == 'reject'" class="audit-log-content">
                  <el-tag  :type="log.action === 'approve' ? 'success' :  'danger'" size="small" effect="plain" style="margin-right: 10px;">
                    {{ log.action === 'approve' ? '审核通过' : '审核拒绝' }}
                  </el-tag>
                  <span class="audit-reason">{{ log.reason }}</span>
                </div>
                <div v-else class="audit-log-content">
                     <span class="audit-reason">{{ log.reason }}</span>
                </div>
              </div>
            </div>
            <div v-else class="no-audit-logs">
              <el-empty description="暂无审核记录" size="small"></el-empty>
            </div>
          </div>
        </div>
      </div>

    </el-dialog>

    <el-image-viewer
      v-if="viewerVisible"
      :on-close="() => viewerVisible = false"
      :url-list="[currentImage]"
    />
  </div>
</template>

<script>
export default {
  name: 'BrokerAuthAudit',
  data() {
    return {
      loading: false,
      auditLoading: false,
      detailVisible: false,
      viewerVisible: false,
      currentImage: '',
      currentRow: null,
      searchForm: {
        brokerInfo: '',
        authStatus: '',
        createTime: ''
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      auditForm: {
        remark: ''
      },
      auditLogs: [],
      isAuditMode: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          ...this.searchForm
        }
        const res = await this.$http.get('/admin/broker/auth/list', { params })
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.$message.error(res.data.message || '加载失败')
        }
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    getStatusType(status) {
      const map = { pending: 'warning', approved: 'success', rejected: 'danger' }
      return map[status] || 'info'
    },
    
    getStatusText(status) {
      const map = { pending: '待审核', approved: '已通过', rejected: '已拒绝' }
      return map[status] || status
    },
    
    getImageUrl(url) {
      // 处理图片URL，确保是完整地址
      if (!url) return ''
      // 如果已经是完整URL，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 如果是相对路径，拼接完整地址
      if (url.startsWith('/')) {
        return 'http://rc6fad9a.natappfree.cc' + url
      }
      return url
    },
    
    getMaskedPhone(phone) {
      if (!phone) return '-'
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1-****-$2')
    },
    
    getMaskedId(idCard) {
      if (!idCard) return '-'
      return idCard.replace(/(\d{3})\d{12}(\d{3})/, '$1***********$2')
    },

    handleView(row, mode = 'view') {
      // 跳转到详情页面
      this.$router.push({
        path: `/broker-auth-audit-detail/${row.id}`,
        query: { mode: mode }
      })
    },
    
    async loadAuditLogs(targetId, auditType) {
      try {
        const res = await this.$http.get('/admin/audit/logs', {
          params: { targetId, auditType }
        })
        if (res.data.code === 200) {
          this.auditLogs = res.data.data
        } else {
          this.auditLogs = []
        }
      } catch (e) {
        // 模拟数据
        this.auditLogs = []
      }
    },

    handleApprove(row) {
      this.currentRow = row
      this.auditForm.remark = ''
      this.detailVisible = true
    },

    handleReject(row) {
      this.currentRow = row
      this.auditForm.remark = ''
      this.detailVisible = true
    },

    async confirmApprove() {
      this.auditLoading = true
      try {
        const res = await this.$http.post('/admin/broker/auth/approve', {
          companyId: this.currentRow.id,
          remark: this.auditForm.remark
        })
        if (res.data.code === 200) {
          this.$message.success('审核通过成功')
          this.detailVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.message || '操作失败')
        }
      } catch (e) {
        this.$message.success('审核通过成功')
        this.detailVisible = false
        this.loadData()
      } finally {
        this.auditForm.remark = ''
        this.auditLoading = false
      }
    },

    async confirmReject() {
      if (!this.auditForm.remark.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.auditLoading = true
      try {
        const res = await this.$http.post('/admin/broker/auth/reject', {
          companyId: this.currentRow.id,
          remark: this.auditForm.remark
        })
        if (res.data.code === 200) {
          this.$message.success('审核拒绝成功')
          this.detailVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.message || '操作失败')
        }
      } catch (e) {
        this.$message.success('审核拒绝成功')
        this.detailVisible = false
        this.loadData()
      } finally {
        this.auditLoading = false
        this.auditForm.remark = ''
      }
    },

    previewImage(src) {
      if (src) {
        this.currentImage = this.getImageUrl(src)
        this.viewerVisible = true
      } else {
        this.$message.info('暂无图片')
      }
    },

    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    
    resetSearch() {
      this.searchForm = {
        brokerInfo: '',
        authStatus: '',
        createTime: ''
      }
      this.currentPage = 1
      this.loadData()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },

    handlePageChange(val) {
      this.currentPage = val
      this.loadData()
    },
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.broker-auth-audit {
  padding: 5px;
}

.search-form {
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.detail-desc {
  margin-bottom: 20px;
}

.label-bold {
  font-weight: 600;
}

.company-name {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.highlight-text {
  color: #409EFF;
  font-weight: 500;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 20px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 5px;
  color: #409EFF;
}

.image-single {
  display: flex;
  justify-content: center;
}

.image-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.image-item {
  flex: 1;
  min-width: 300px;
}

.image-item.full-width {
  flex: 100%;
}

.image-label {
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
}

.image-wrapper {
  width: 100%;
  height: 200px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  transition: all 0.3s;
}

.image-wrapper:hover {
  border-color: #409EFF;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-empty {
  text-align: center;
  color: #909399;
}

.image-empty i {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}

.audit-section {
  background: #f5f7fa;
  padding: 0 20px 10px 20px;
  border-radius: 6px;
  margin-top: 10px;
}

.dialog-footer {
  text-align: center;
}

.audit-trail-section {
  margin-top: 20px;
}

.audit-trail {
  background: #f9f9f9;
  border-radius: 6px;
  padding: 15px;
}

.audit-log-item {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.audit-log-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.audit-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.audit-operator {
  font-weight: 500;
  color: #303133;
}

.audit-time {
  font-size: 12px;
  color: #909399;
}

.audit-log-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.audit-reason {
  color: #606266;
  flex: 1;
  min-width: 200px;
}

.no-audit-logs {
  padding: 30px 0;
  text-align: center;
}

/* 详情页新样式 */
.detail-container {
  display: flex;
  gap: 30px;
}

.left-section {
  flex: 1;
  min-width: 500px;
}

.right-section {
  width: 300px;
  min-width: 280px;
}

.basic-info {
  background: #ffffff;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
}

.clickable-field {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #66b1ff;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0;
}

.info-grid-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  height: 60px;
  border-right: 1px solid #ebeef5;
}

.info-grid-item:last-child {
  border-right: none;
}

.info-grid-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 4px;
}

.info-grid-value {
  font-size: 14px;
  color: #303133;
  font-weight: 400;
}

.license-section {
  margin-bottom: 20px;
}

.license-image {
  width: 100%;
  height: 300px;
  object-fit: contain;
}

.license-empty {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.audit-section {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.audit-buttons {
  margin-top: 15px;
  text-align: right;
}

.audit-result {
  padding: 10px 0;
}

.audit-remark {
  margin-top: 15px;
}

.remark-label {
  font-weight: 500;
  color: #606266;
  margin-bottom: 5px;
}

.remark-content {
  color: #303133;
  line-height: 1.5;
}
</style>
